import React from "react";
import { Container, Divider, Image, Header } from "semantic-ui-react";
const imageList = [
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/learnapp%2F1.png?alt=media&token=e07bf453-69cc-4802-a810-4c4fd237d806",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/learnapp%2F1.png?alt=media&token=e07bf453-69cc-4802-a810-4c4fd237d806"
];
export const learn_app = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Learn app</Header.Content>
        <Header.Subheader>
          <p>
            Learn is Zaya's core learning platform for the classcloud. Had
            redesigned and developed some of the key aspect of the app. Few of
            the screen shot of how preview of how course list look like, are
            given below.
          </p>
          <p>Credit : Re-designed and co-developed</p>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image.Group>
        {imageList.map((url, i) => {
          return <Image key={i} rounded src={url} />;
        })}
      </Image.Group>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/learn_app.js